import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const CheckoutForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom: "",
    adresse: "",
    ville: "",
    codePostal: "",
    email: "",
  });

  useEffect(() => {
    // ✅ pré-remplissage si user
    try {
      const stored = localStorage.getItem("user");
      if (!stored) return;
      const parsed = JSON.parse(stored);
      const u = parsed.user || parsed;
      if (u?.email) setFormData((p) => ({ ...p, email: u.email }));
      if (u?.name) setFormData((p) => ({ ...p, nom: u.name }));
    } catch {}
  }, []);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("checkoutInfo", JSON.stringify(formData));
    navigate("/recapitulatif");
  };

  return (
    <div className="page">
      <Helmet>
        <title>Livraison – Deenzine</title>
        <meta name="description" content="Renseigne tes informations de livraison pour finaliser ta commande." />
        <link rel="canonical" href={window.location.origin + "/checkout-form"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 720, margin: "0 auto" }}>
            <div className="badge">Étape 1/2 • Livraison</div>
            <h1 className="h2" style={{ color: "var(--brand)", marginTop: 10 }}>Informations de livraison</h1>
            <p className="p">On utilise ces infos uniquement pour expédier ta commande.</p>

            <form onSubmit={handleSubmit} style={{ marginTop: 18 }}>
              <div className="grid">
                <div style={{ gridColumn: "span 6" }}>
                  <label className="p" htmlFor="nom" style={{ display: "block", marginBottom: 6 }}>Nom complet</label>
                  <input id="nom" name="nom" className="input" value={formData.nom} onChange={handleChange} required />
                </div>

                <div style={{ gridColumn: "span 6" }}>
                  <label className="p" htmlFor="email" style={{ display: "block", marginBottom: 6 }}>Email</label>
                  <input id="email" name="email" type="email" className="input" value={formData.email} onChange={handleChange} required />
                </div>

                <div style={{ gridColumn: "span 12" }}>
                  <label className="p" htmlFor="adresse" style={{ display: "block", marginBottom: 6 }}>Adresse</label>
                  <input id="adresse" name="adresse" className="input" value={formData.adresse} onChange={handleChange} required />
                </div>

                <div style={{ gridColumn: "span 6" }}>
                  <label className="p" htmlFor="ville" style={{ display: "block", marginBottom: 6 }}>Ville</label>
                  <input id="ville" name="ville" className="input" value={formData.ville} onChange={handleChange} required />
                </div>

                <div style={{ gridColumn: "span 6" }}>
                  <label className="p" htmlFor="codePostal" style={{ display: "block", marginBottom: 6 }}>Code postal</label>
                  <input id="codePostal" name="codePostal" className="input" value={formData.codePostal} onChange={handleChange} required />
                </div>
              </div>

              <button type="submit" className="btn" style={{ width: "100%", marginTop: 16 }}>
                Continuer →
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CheckoutForm;
